import React, { Component } from "react";
import {
	View,
	StyleSheet,
	KeyboardAvoidingView,
	TextInput,
	Platform,
	Image,
} from "react-native";
import { translate } from "react-i18next";

import validation from "utils/validation";
import BackgroundImage from "components/BackgroundImage";
import Textfield from "components/Textfield";
import Header from "components/Header";
import TextLink from "components/TextLink";
import ViewScroll from "components/ViewScroll";
import Button from "components/Button";
import Text from "components/StyledText";

import { push, reset } from "utils/navigation";
import { resetPassword } from "utils/awsAuth";

import * as x from "../../../styles/css";

class ForgotPassword extends Component {
	static navigationOptions = {
		header: null,
	};

	constructor(props) {
		super(props);

		this.state = {
			error: { email: "" },
			inputs: {
				email: "",
			},
			loading: false,
			reset: false,
		};

		this.backToLogin = this.backToLogin.bind(this);
		this.resetPassword = this.resetPassword.bind(this);
	}

	resetPassword() {
		const { error, inputs } = this.state;
		const { t } = this.props;

		const validateInputs = validation(inputs);

		if (validateInputs) {
			Object.keys(validateInputs).forEach(
				x => (validateInputs[x] = validateInputs[x][0])
			);
			Object.keys(validateInputs).map((key, index) => {
				validateInputs[key] = this.props.t(validateInputs[key]);
			});

			if (validateInputs.email) {
				return this.setState({
					error: { ...validateInputs },
					loading: false,
				});
			}
		}

		resetPassword(inputs.email)
			.then(success => {
				this.setState({
					reset: true,
				});
			})
			.catch(err => {
				this.setState({
					error: {
						...error,
						email: t(err.message),
					},
				});
			});
	}

	backToLogin() {
		reset({ web: "/login", mobile: "Login" }, this.props);
	}

	render() {
		const { error, inputs, reset } = this.state;
		const { t } = this.props;

		const body = reset ? (
			<View style={[x.mt.auto]}>
				<Header style={{ textAlign: "center" }}>
					{t("userAuth.passwordReset.passwordResetSent")}
				</Header>
				<Text style={{ textAlign: "center" }}>
					{t("userAuth.passwordReset.passwordResetSentCheck")}
				</Text>
			</View>
		) : (
			<View>
				<View>
					<Header>{t("userAuth.passwordReset.title")}</Header>
					<Text help>{t("userAuth.passwordReset.help")}</Text>
				</View>
				<View
					style={[
						x.justifyContent.flexStart,
						x.alignItems.stretch,
						styles.loginBody,
					]}
				>
					<Textfield
						label="Email Address"
						error={error.email}
						value={inputs.email}
						onChangeText={email =>
							this.setState({
								inputs: { ...inputs, email },
							})
						}
						keyboardType="email-address"
					/>
					<Button
						onPress={this.resetPassword}
						title={t("labels.resetPassword")}
						color={x.colors.default}
						disabled={this.state.loading}
					/>
				</View>
			</View>
		);

		return (
			<ViewScroll>
				<View style={[x.d.flex, styles.background]}>
					{body}
					<View style={[x.d.flex, x.mt.three, x.justifyContent.flexStart, x.alignItems.center]}>
						<TextLink
							onPress={this.backToLogin}
							title={t("labels.backToLogin")}
							color={x.colors.default}
						/>
					</View>
				</View>
			</ViewScroll>
		);
	}
}

const styles = StyleSheet.create({
	app: {
		paddingLeft: "15%",
		paddingRight: "15%",
		marginBottom: "20%",
		marginTop: "15%",
	},
	appHeader: {
		padding: 20,
		height: 100,
	},
	appTitle: {
		fontSize: 16,
		color: "white",
	},
	appIntro: {
		flex: 2,
		fontSize: 30,
		textAlign: "center",
	},
	loginBody: {
		marginTop: 40,
	},
	background: {
		backgroundColor: "#fff",
		...(Platform.OS === "web"
			? { maxHeight: 600, minHeight: 500, width: "100%" }
			: {}),
	},
});

export default translate()(ForgotPassword);



// WEBPACK FOOTER //
// ./src/views/UserAuth/ForgotPassword/index.js